import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../store_redux'
import ModalAtom from '../../@atoms/to_layout/modal/modal.atom'
import {hideModal} from '../../store_redux/reducer/modal.reducer'
import BestDateComponent from '../best_date/best_date.component'
import EditLocationComponent from '../edit_location/edit_location.component'
import NotifyPrefsComponent from '../notify_prefs/notify_prefs.component'
import SpecialInstructionsComponent from '../special_instructions/special_instructions.component'
import StandardDateChoiceComponent from '../standard_date_choice/standard_date_choice.component'

const OrderDetailModalComponent: React.FC = function () {
  const modalState = useSelector((state: RootState) => state.modal)
  const dispatch = useDispatch()

  const onCLoseModal = () => {
    dispatch(hideModal())
  }

  switch (modalState.type) {
    case 'SPECIAL_INSTRUCTION':
      return (
        <ModalAtom
          open={modalState.showModal}
          ap_type="special_instruction_modal"
          onClose={onCLoseModal}
        >
          <SpecialInstructionsComponent />
        </ModalAtom>
      )
    case 'BEST_DATE':
      return (
        <ModalAtom
          open={modalState.showModal}
          ap_type="best_date_modal"
          onClose={onCLoseModal}
        >
          <BestDateComponent />
        </ModalAtom>
      )
    case 'STANDARD_DATE_CHOICE':
      return (
        <ModalAtom
          open={modalState.showModal}
          ap_type="standard_date_choice_modal"
          onClose={onCLoseModal}
        >
          <StandardDateChoiceComponent />
        </ModalAtom>
      )
    case 'LOCATION':
      return (
        <ModalAtom
          open={modalState.showModal}
          ap_type="location_modal"
          onClose={onCLoseModal}
        >
          <EditLocationComponent />
        </ModalAtom>
      )
    case 'NOTIFY_PREFS':
      return (
        <ModalAtom
          open={modalState.showModal}
          ap_type="notify_prefs_modal"
          onClose={onCLoseModal}
        >
          <NotifyPrefsComponent />
        </ModalAtom>
      )
    default:
      return null
  }
}

export default OrderDetailModalComponent
